"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LocalRootsExpertCare() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="local-roots-expert-care" className="bg-background py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-6 md:px-12 max-w-7xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        {}
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground mb-16 max-w-4xl leading-tight tracking-tight">About Us</h2>

        {}
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-8 md:gap-16 items-stretch">
          {}
          <div className="font-sans text-muted-foreground text-lg leading-relaxed space-y-6">
            <p>Taillet Real Estate and Property Management is a military family owned team proudly serving Abilene and the surrounding Big Country. Having grown up in the Abilene area, we bring deep local roots, firsthand market knowledge, and a genuine commitment to our community.</p>
            <p>With over three years of hands-on property management experience, we understand what it takes to protect your investment and keep properties performing at their best. From marketing and tenant placement to maintenance coordination and financial oversight, we approach every property with professionalism, organization, and care.</p>
          </div>

          {}
          <div className="flex justify-center md:justify-center py-4 md:py-0">
            {}
            <Separator orientation="horizontal" className="md:hidden w-24 bg-secondary h-0.5" />
            {}
            <Separator orientation="vertical" className="hidden md:block h-full min-h-[200px] w-px bg-secondary" />
          </div>

          {}
          <div className="font-sans text-muted-foreground text-lg leading-relaxed space-y-6">
            <p>Both of us hold college degrees in business, giving us a strong foundation in operations, finance, and strategic planning. Our backgrounds in education and military service have shaped our values—integrity, clear communication, accountability, and attention to detail. We believe in doing things the right way, serving others well, and following through on our commitments.</p>
            <p>As local experts, we understand Abilene’s neighborhoods, rental trends, and tenant expectations. Whether you’re renting out your first home or growing your portfolio, we provide dependable, full-service management designed to reduce stress and maximize returns.</p>
          </div>
        </div>
      </div>
    </section>;
}